<div fxLayout="column">
  <!-- IE requires all fxLayout="column" elements to have the child contents wrapped in a plain div tag -->
  <div *ngIf="isBrowserIE; else footerMainFlexColumnTemplate" [ngClass]="{ 'ie-display': isBrowserIE }">
    <div style="max-height: 64px; min-height: 64px;"></div>
    <ng-container *ngTemplateOutlet="footerMainFlexColumnTemplate"></ng-container>
  </div>
</div>

<ng-template #footerMainFlexColumnTemplate>
  <div fxFlex.lt-md="24px" fxFlex.gt-sm="64px"></div>
  <div
    fxFlex="100%"
    fxLayout="row"
    fxLayout.lt-md="column"
    fxLayoutGap.lt-md="10px"
    *ngIf="navigationOptions.footerOptions.displayHoursOfOperation"
  >
    <div *ngIf="isBrowserIE && media.isActive('lt-md'); else footerHoursOfOperationFlexColumnTemplate">
      <ng-container *ngTemplateOutlet="footerHoursOfOperationFlexColumnTemplate"></ng-container>
    </div>
  </div>
  <div fxFlex="100%" fxLayout="row" fxLayout.lt-md="column" fxLayoutGap.lt-md="10px">
    <div *ngIf="isBrowserIE && media.isActive('lt-md'); else footerTopOptionsFlexColumnTemplate">
      <ng-container *ngTemplateOutlet="footerTopOptionsFlexColumnTemplate"></ng-container>
    </div>
  </div>
  <div fxFlex="100%" fxLayout="row" fxLayout.lt-md="column" fxLayoutGap.lt-md="10px">
    <div *ngIf="isBrowserIE && media.isActive('lt-md'); else footerMiddleOptionsFlexColumnTemplate">
      <ng-container *ngTemplateOutlet="footerMiddleOptionsFlexColumnTemplate"></ng-container>
    </div>
  </div>
  <div fxFlex="100%" fxLayout="row" fxLayout.lt-md="column" fxLayoutGap.lt-md="10px">
    <div *ngIf="isBrowserIE && media.isActive('lt-md'); else footerBottomOptionsFlexColumnTemplate">
      <ng-container *ngTemplateOutlet="footerBottomOptionsFlexColumnTemplate"></ng-container>
    </div>
  </div>
  <div fxFlex="100%" fxLayout="row" fxLayout.lt-md="column" fxLayoutGap.lt-md="10px" *ngIf="manualCompanyCodeChangeEnabled()">
    <div *ngIf="isBrowserIE && media.isActive('lt-md'); else footerCompanyCodeOptionsFlexColumnTemplate">
      <ng-container *ngTemplateOutlet="footerCompanyCodeOptionsFlexColumnTemplate"></ng-container>
    </div>
  </div>
</ng-template>

<ng-template #footerHoursOfOperationFlexColumnTemplate>
  <div fxFlex="5%" fxHide.lt-md></div>
  <div fxFlex="90%" fxLayoutAlign="end start" fxLayoutAlign.lt-md="center center" ngStyle.lt-md="padding-left: 8px; padding-right: 8px">
    <div
      class="footer-text highlighted-display-text normal-paragraph-spacing"
      style="text-align: right;"
      ngStyle.lt-md="text-align: center;"
    >
      <b><span i18n="@@page-footer.hours-of-operation.1">page-footer.hours-of-operation.1</span></b
      ><br />
      {{ companyInformation.hoursOpen }}&nbsp;{{ companyInformation.dayOfWeekOpen }}
    </div>
  </div>
  <div fxFlex="5%" fxHide.lt-md></div>
</ng-template>

<ng-template #footerTopOptionsFlexColumnTemplate>
  <div fxFlex="5%" fxHide.lt-md></div>
  <div
    fxFlex.lt-md="90%"
    fxFlex.gt-sm="30%"
    fxLayoutAlign="start start"
    fxLayoutAlign.lt-md="center center"
    ngStyle.lt-md="padding-left: 8px; padding-right: 8px"
  >
    <div>
      <a target="_blank" [href]="companyInformation.privacyPolicyURL" class="footer-link" i18n="@@page-footer.privacy-policy"
        >page-footer.privacy-policy</a
      >
    </div>
  </div>
  <div
    fxFlex.lt-md="90%"
    fxFlex.gt-sm="30%"
    fxLayoutAlign="center start"
    fxLayoutAlign.lt-md="center center"
    ngStyle.lt-md="padding-left: 8px; padding-right: 8px"
  >
    <div>
      <a target="_blank" [href]="companyInformation.browserRequirementsURL" class="footer-link" i18n="@@page-footer.browser-requirements"
        >page-footer.browser-requirements</a
      >
    </div>
  </div>
  <div
    fxFlex.lt-md="90%"
    fxFlex.gt-sm="30%"
    fxLayoutAlign="end start"
    fxLayoutAlign.lt-md="center center"
    ngStyle.lt-md="padding-left: 8px; padding-right: 8px"
  >
    <div>
      <a target="_blank" [href]="companyInformation.termsConditionsURL" class="footer-link" i18n="@@page-footer.terms-conditions"
        >page-footer.terms-conditions</a
      >
    </div>
  </div>
  <div fxFlex="5%" fxHide.lt-md></div>
</ng-template>

<ng-template #footerMiddleOptionsFlexColumnTemplate>
  <div fxFlex="5%" fxHide.lt-md></div>
  <div fxFlex="90%" fxLayoutAlign="center start" fxLayoutAlign.lt-md="center center" ngStyle.lt-md="padding-left: 8px; padding-right: 8px">
    <div class="footer-text" style="text-align: center;">
      &copy; {{ currentDate.getFullYear() }} {{ companyInformation.companyName }}.&nbsp;
      <span i18n="@@page-footer.copyright">page-footer.copyright</span>
    </div>
  </div>
  <div fxFlex="5%" fxHide.lt-md></div>
</ng-template>

<ng-template #footerBottomOptionsFlexColumnTemplate>
  <div fxFlex="5%" fxHide.lt-md></div>
  <div fxFlex="90%" fxLayoutAlign="center start" fxLayoutAlign.lt-md="center center" ngStyle.lt-md="padding-left: 8px; padding-right: 8px">
    <div class="footer-text" style="text-align: center;" i18n="@@page-footer.accept-use">page-footer.accept-use</div>
  </div>
  <div fxFlex="5%" fxHide.lt-md></div>
</ng-template>

<ng-template #footerCompanyCodeOptionsFlexColumnTemplate>
  <div fxFlex="5%" fxHide.lt-md></div>
  <div
    fxFlex="90%"
    fxLayoutAlign="center start"
    fxLayoutAlign.lt-md="center center"
    class="large-paragraph-pre-spacing"
    ngStyle.lt-md="padding-left: 8px; padding-right: 8px"
  >
    <div
      fxLayoutAlign="center center"
      fxLayoutAlign.lt-md="center center"
      style="padding-left: 8px; padding-right: 8px"
      *ngFor="let company of this.companyList"
    >
      <div *ngIf="selectManualCompanyEnabled(company.companyCode)">
        <a (click)="selectManualCompany(company.companyCode)" class="footer-link footer-link-button"
          >Select Company: <b>{{ company.companyName }}</b></a
        >
      </div>
      <div *ngIf="!selectManualCompanyEnabled(company.companyCode)">
        <span class="footer-text"
          >Current Company: <b>{{ company.companyName }}</b></span
        >
      </div>
    </div>
  </div>
  <div fxFlex="5%" fxHide.lt-md></div>
</ng-template>
